<template>

    <div class="pu_wrapper">

        <!--================ inc head top =================-->
        <inc_zadmin_head />
        <inc_zadmin_top />
        <inc_zadmin_title />
        <!--================ //inc head top =================-->

        <form id="regiForm">

            <div class="pu_board">
                <div class="pu_row">
                    <div class="pu_contents">

                        <!--================ inc left =================-->
                        <inc_zadmin_left />
                        <!--================ //inc left =================-->

                        <div class="pu_body">
                            <div class="pu_row">
                                <div class="pu_contents">

                                    <div class="pu_row">
                                        <div class="pu_contents">

                                            <table class="pu_table_view" style="width:400px;">

                                                <tbody>

                                                    <tr>
                                                        <th>금제품 시세(돈당)</th>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="prod_1_now" v-model="view_1.PROD_1_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>은제품 시세(돈당)</th>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="prod_2_now" v-model="view_1.PROD_2_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>
                                    </div>


                                    <div class="pu_row">
                                        <div class="pu_contents">

                                            <div class="pu_row_horizon">

                                                <div class="pu_col_lg_11"></div>

                                                <div class="pu_col_lg_1">
                                                    <a class="dev_btn_submit pu_btn pu_btn_regi">
                                                        <i class="fas fa-edit"></i> 저장
                                                    </a>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </form>

        <!--================ inc foot =================-->
        <inc_zadmin_foot />
        <!--================ //inc foot =================-->

    </div>

</template>

<script>
    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";

    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase"
            }),

        }

        , data() {
            return {

                gubun_page: "REGIFORM"

                , rownum: 0    // 번호
                , paging: ""   // 페이징

                , list_1: []
                , list_2: []
                , list_3: []
                , list_4: []

                , view_1: {}
                , view_2: {}
                , view_3: {}
                , view_4: {}

            }
        }

        , methods: {

            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , init() {

                this.getViewData();

            }

            // 데이터 조회
            , getViewData () {

                var qs = this.$GetQueryMap();
                var data = {};
                data["gubun_page"] = this.gubun_page;

                // API 조회
                this.$SendPost("/vue_api/zadmin/set_price_prod/view", data, this.viewDataReturn);

            }

            // 데이터 리턴
            , viewDataReturn (data, err) {

                if (data) {

                    // 데이터 처리
                    if (data.RESULT_YN === "Y") {

                        this.view_1 = data.VIEW_1; // 뷰

                        // dimm 숨기기
                        this.$HideDimmLogo();

                    }

                }

            }

            // 저장
            , saveData () {

                var prod_1_now = $("[name='prod_1_now']");
                if (!prod_1_now.val().trim()) {
                    alert("제품시세(돈당)를 입력해주세요");
                    prod_1_now.focus();
                    return false;
                }

                if (confirm(INFO_CONF_SAVE)) {

                    // dimm 보이기
                    this.$ShowDimmLogo();

                    var data = this.$FormToMap($('#regiForm'));
                    data["gubun_page"] = this.gubun_page;

                    // API 조회
                    this.$SendPost("/vue_api/zadmin/set_price_prod/save", data, this.saveEventReturn);

                }

            }

            // 저장 데이터
            , saveEventReturn (data, err) {

                // dimm 숨기기
                this.$HideDimmLogo();

            }

        }

        , beforeCreate() {
        }

        , created() {
        }

        , beforeMount() {
        }

        , mounted() {
            this.$AfterMounted(this);
        }

        , beforeUpdate() {
        }

        , updated() {
            this.$AfterUpdated(this);
        }

        , beforeDestroy() {
        }

        , destroyed() {
        }

    }

</script>